import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';


class AssignTeamToUser {
  constructor($scope, $window, userInTeamService, userPopupService) {
    'ngInject';

    this.$scope = $scope;
    this.$window = $window;
    this.userInTeamService = userInTeamService;
    this.userPopupService = userPopupService;
    this.currentTab = 'general';
  }

  $onInit() {
    this.userInTeamService.getAssingTeamToUserTemplate({ groupId: this.resolve.groupId, userId: this.resolve.userId })
      .then((template) => {
        if (template === null) {
            ttb.Notifications.ShowErrorMessage('User Configuration', 'Cannot assign the team');
            this.dismiss();
            return;
        }

        this.template = template;
        this.selectedProject = template.projects.length && template.projects[0];
        this.roleOptions = template.roles;
        this.selectedRole = find(this.roleOptions, x => x.id === this.template.roleId);
        this.allTeamOptions = template.teams;
        this.onProjectChange();
        this.updateWeekDayConfig();
      });
    this.$scope.$watch('$ctrl.template.workingDayInherit', () => this.updateWeekDayConfig());
  }

    add() {
        this.loading = true;
        this.userInTeamService.assingUserAndTeam({
            userId: this.template.userId,
            teamId: this.selectedTeam.id,
            isActive: this.template.isActive,
            roleId: this.selectedRole.id,
            workingDayInherit: this.template.workingDayInherit,
            workingTimings: this.template.workingTimings,
            dayOverrides: this.template.dayOverrides,
            projectId: this.selectedProject.id,
        }).then(() => {
            this.loading = false;
            this.close({
                $value: {
                    userId: this.template.userId,
                    teamId: this.selectedTeam.id,
                },
            });
        }, () => {
            this.loading = false;
        });
  }

  onTabChange(tab) {
    if (!this.selectedTeam) return;
    this.currentTab = tab;
  }

  updateWeekDayConfig() {
    if (!this.template || !this.template.teamWorkingTimings) return;
    this.currentWeekDayConfig = cloneDeep(this.template.workingDayInherit
      ? this.template.teamWorkingTimings.weekDayConfig
      : this.template.workingTimings.weekDayConfig);
  }

  onDaysOfWeekChange() {
    this.updateWeekDayConfig();
  }

  onSelectedTeam() {
    this.template.teamWorkingTimings = this.selectedTeam.workingTimings;
    this.updateWeekDayConfig();
  }

  onProjectChange() {
    this.teamOptions = this.allTeamOptions.filter(team => team.projectId === this.selectedProject.id);
    this.selectedTeam = this.teamOptions.length && this.teamOptions[0];
    this.onSelectedTeam();
  }

  assignToProject() {
    this.dismiss();
    this.userPopupService.openProjectToUser({
      groupId: this.resolve.groupId,
      userId: this.resolve.userId,
    }).then(() => {
      this.resolve.parent.assignToTeam();
    });
  }
}

export default AssignTeamToUser;



// WEBPACK FOOTER //
// ./components/popups/user-popup/assign-team-to-user/assign-team-to-user.controller.js